module.exports = __webpack_public_path__ + "img/places-4.6cec0a50.jpg";